import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "../app/Components/Shared/Spinner";


//const Error404 = lazy(() => import("./page/error-pages/Error404"));
const Error500 = lazy(() => import("./page/error-pages/Error500"));

const Login = lazy(() => import("./page/user-pages/Login"));
const Lockscreen = lazy(() => import("./page/user-pages/Lockscreen"));
const RecoveryPassword = lazy(() => import("./page/user-pages/RecoveryPassword"));

//Fortaleciendo Vinculos
class AppRoutesNotAutorization extends Component {
  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route path="/user-pages/lockscreen" component={Lockscreen} />
          <Route path="/user-pages/RecoveryPassword" component={RecoveryPassword} />
          <Route path="/error-pages/error-500" component={Error500} />
          <Route path="/login" component={Login} />
          <Redirect from="*" exact to="/login" />
          <Redirect to="/login" />  
        </Switch>
      </Suspense>
    );
  }
}



export default AppRoutesNotAutorization;
